module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Up-down-f28f99965ff8f82f7fce2d40d71eef75.svg";